// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WVXIrG46w8zIHa768o0j {
  border: 1px solid #f0f0f0;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Project/Assets/Files/index.module.less"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;AACF","sourcesContent":[".table {\n  border: 1px solid #f0f0f0;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `WVXIrG46w8zIHa768o0j`
};
export default ___CSS_LOADER_EXPORT___;
